import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_LISTING_PRE_LEASE_STATS } from 'api/actionTypes';

export default async function getListingPreLeaseStats(
  { state, apiClient },
  { listingStatsId, listingId, sinceDate, forceRefresh },
) {
  typeCheck('listingStatsId::NonEmptyString', listingStatsId);

  const partnerListingStatsRoute = ['partners', 'listingStats', listingStatsId];

  if (state.get(partnerListingStatsRoute) && !forceRefresh) {
    return state.get(partnerListingStatsRoute);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_LISTING_PRE_LEASE_STATS,
    queryId: listingStatsId,
    state: state,
    payload: {
      listingId: listingId,
      sinceDate: sinceDate,
    },
    onSuccess(partnerListingStats) {
      state.set(partnerListingStatsRoute, partnerListingStats);
      state.commit();
    },
  });
}
